const style1 = { 
    backgroundColor: "#fff",
    display: "inline-block",
    fontFamily:"Roboto,sans-serif",
    color: "#a7a7a7",
    fontSize: "11px",
    width: "100%",
    maxWidth: "475px" 
}
const style2 = {
    padding:"0",
    margin: "0",
    textAlign: "left"
}
const style3 = { 
    color:"#a7a7a7",
    textDecoration: "none",
    fontWeight: "normal",
    border: "none",
    display: "inline-block"
}
const style4 = { 
    overflow: "hidden",
    position:"relative",
    height:"0",
    padding:"125.05263% 0 0 0", 
    width:"100%"
}
const style5 = { 
    display:"inline-block",
    position:"absolute",
    top:"0",
    left:"0",
    width:"100%",
    height:"100%",
    margin:"0"
}

function SheenFultonAltEmbed(){
        return (
            <>
            <div class="getty embed image" style={style1}><div style={style2}><a href="https://www.gettyimages.com/detail/82256799" target="_blank" rel="noreferrer" style={style3}>Embed from Getty Images</a></div><div style={style4}><iframe src="//embed.gettyimages.com/embed/82256799?et=s2gw6w0lRtVUmFgR0Tihiw&tld=com&sig=fRTCQhdgv9e2g3o_l3s_SwgCZtEG5gjbW4r69ZyV29U=&caption=true&ver=1" title="Fulton Sheen" scrolling="no" frameBorder="0" width="475" height="594" style={style5}></iframe></div></div>
            </>
        );
};
export default SheenFultonAltEmbed;